import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-x-ray-visits-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './x-ray-visits-skeleton.component.html',
  styleUrl: './x-ray-visits-skeleton.component.scss'
})
export class XRayVisitsSkeletonComponent {

}
